<template>
  <ion-app v-if="blockByVersion" :class="{metro: systemVersion == 'pl'}">
    <update-component></update-component>
  </ion-app>
  <ion-app v-else-if="configError" :class="{metro: systemVersion == 'pl'}">
    <config-error-component></config-error-component>
  </ion-app>
  <ion-app v-else :class="{metro: systemVersion == 'pl'}">
    <div class="lottie-container" v-if="showLottie">
        <lottie-animation path="assets/animations/lottieflow-countdown-13-1-f8c300-easey.json" v-if="systemVersion === 'pl'"></lottie-animation>
        <lottie-animation path="assets/animations/55213-blue-house.json" v-else></lottie-animation>
    </div>
    <dh-menu></dh-menu>
    <ai-assitant></ai-assitant>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import dhMenu from './components/pageComponents/dhMenu.vue';
import updateComponent from './components/updateComponent.vue';
import configErrorComponent from './components/configErrorComponent';
import axios from "axios";
import {addPushNotificationListeners, registerNotifications} from './js/pushNotifications';
import {getSystemVersion} from './js/functions.js';
import AiAssitant from "@/components/pageComponents/aiAssitant.vue";

export default defineComponent({
  name: 'App',
  components: {
    AiAssitant,
    IonApp,
    IonRouterOutlet,
    LottieAnimation,
    dhMenu,
    updateComponent,
    configErrorComponent,
  },
  data() {
    return {
      showLottie: false,
      blockByVersion: false,
      configError: false,
      systemVersion: getSystemVersion()
    }
  },
  async mounted() {
    this.handleLottie();

    await addPushNotificationListeners();
    await registerNotifications();

    await this.checkVersion();
    this.setSystemVersion();
  },
  methods: {
    handleLottie() {
      const disableLottie = localStorage.getItem('disableLottie');
      if (disableLottie == 1) {
        localStorage.removeItem('disableLottie');
        this.showLottie = false;
        return false;
      }

      let self = this;
      this.showLottie = true;

      setTimeout(function() {
        self.showLottie = false;
      }, 3000);
    },
    async checkVersion() {
      let self = this;
      this.blockByVersion = false;

      const apiURL = this.APIURL('verionInformation');
      console.log(`[dh.matrix][verionInformation] ${apiURL}`);

      await axios.get(apiURL).then(function(response) {
          if (response.data != null && response.data != undefined && response.data.main != null && response.data.main != undefined && response.data.sub != null && response.data.sub != undefined) {
            const updateInformation = (response.data.updateInformation != null && response.data.updateInformation != undefined) ? response.data.updateInformation : false;
            const updateURL = (response.data.updateURL != null && response.data.updateURL != undefined) ? response.data.updateURL : false;

            localStorage.setItem('updateInformation', updateInformation);
            localStorage.setItem('updateURL', updateURL);

            if (response.data.main > self.config.app.mainVersion || response.data.sub > self.config.app.subVersion) {
              self.blockByVersion = true;
            }
          }
      }).catch(function () {
          console.log('Error while checking version')
      });
    },
    setSystemVersion() {
      document.documentElement.setAttribute('systemversion', this.systemVersion);
    }
  }
});
</script>